import { render, staticRenderFns } from "./PowerBiModuleRoot.vue?vue&type=template&id=c76a66e4&scoped=true&lang=html&"
import script from "./PowerBiModuleRoot.vue?vue&type=script&lang=js&"
export * from "./PowerBiModuleRoot.vue?vue&type=script&lang=js&"
import style0 from "./PowerBiModuleRoot.vue?vue&type=style&index=0&id=c76a66e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c76a66e4",
  null
  
)

export default component.exports